/**
 * SKALA SUWAKA CENY: 1 000–8 000+ zł, GĘSTSZA W ŚRODKU (decyzja Piotra 28.09 — „suwak
 * łączący oba rozwiązania": skala nieliniowa + pola „od / do" do wpisania kwoty).
 *
 * DLACZEGO TAKIE ODCINKI. Rozkład aktywnych ofert całych mieszkań (6 414, flat-hero-piotr,
 * 28.09, liczone przez scripts/rest.sh na `flat.offers`):
 *   1 000–2 000 zł     98 ofert   1,5%   →  10% toru, krok 250 zł (4 kroki)
 *   2 000–5 000 zł  5 756 ofert  89,7%   →  75% toru, krok 100 zł (30 kroków)
 *   5 000–8 000 zł    464 oferty  7,2%   →  15% toru, krok 500 zł (6 kroków)
 *   od 8 000 zł        96 ofert   1,5%   →  prawy kraniec „8 000+"
 *   poniżej 1 000 zł    0 ofert
 * Przy skali liniowej 1 000–8 000 (695af4f1) 250 zł w środku to ok. 11 px na telefonie
 * (przypadek Piotra 2 900–3 150 zł: uchwyty stały 11 px od siebie); tutaj ok. 21 px.
 *
 * JEDNA DEFINICJA, TRZECH UŻYTKOWNIKÓW: suwak (pozycje uchwytów), histogram (granice koszyków
 * idą do `flat.offers_price_histogram` jako `p_granice`) i bramka `scripts/check-histogram.mjs`
 * (czyta granice ze strony, `data-granice`). Każdy krok suwaka to jeden koszyk histogramu,
 * więc słupki mają równą szerokość na ekranie, a uchwyt zawsze stoi NA GRANICY koszyka — suma
 * słupków w zaznaczeniu jest wtedy dokładnie liczbą ofert na liście.
 *
 * SKRAJE ZNACZĄ „BEZ GRANICY": lewy uchwyt na 1 000 = brak dolnej granicy, prawy na 8 000 =
 * „8 000+". Dowolną kwotę (np. 2 950 zł) wpisuje się w pola „od / do"; uchwyt staje wtedy
 * między krokami, w miejscu tej kwoty na skali.
 */
function kroki(od: number, doKwoty: number, krok: number): number[] {
  const wynik: number[] = [];
  for (let v = od; v < doKwoty; v += krok) wynik.push(v);
  return wynik;
}

export const GRANICE_CENY: readonly number[] = [
  ...kroki(1_000, 2_000, 250),
  ...kroki(2_000, 5_000, 100),
  ...kroki(5_000, 8_000, 500),
  8_000,
];

export const CENA_MIN = GRANICE_CENY[0];
export const CENA_MAX = GRANICE_CENY[GRANICE_CENY.length - 1];
/** Liczba kroków suwaka = liczba koszyków histogramu na skali (bez ogonów). */
export const LICZBA_KROKOW = GRANICE_CENY.length - 1;

/** Kwota w złotówkach dla pozycji uchwytu (0…LICZBA_KROKOW). */
export function kwotaZPozycji(pozycja: number): number {
  const i = Math.min(LICZBA_KROKOW, Math.max(0, Math.round(pozycja)));
  return GRANICE_CENY[i];
}

/**
 * Pozycja na torze dla dowolnej kwoty — także spoza kroków (kwota wpisana w pole albo stary
 * adres). Między granicami liniowo, poza skalą przycięta do krańca.
 */
export function pozycjaZKwoty(kwota: number): number {
  if (kwota <= CENA_MIN) return 0;
  if (kwota >= CENA_MAX) return LICZBA_KROKOW;
  let j = 0;
  while (GRANICE_CENY[j + 1] <= kwota) j += 1;
  const dol = GRANICE_CENY[j];
  const gora = GRANICE_CENY[j + 1];
  return j + (kwota - dol) / (gora - dol);
}

/** Pozycje uchwytów dla filtra; brak granicy = kraniec toru. */
export function wartoscSuwaka(rentMin?: number, rentMax?: number): [number, number] {
  const lo = rentMin == null ? 0 : pozycjaZKwoty(rentMin);
  const hi = rentMax == null ? LICZBA_KROKOW : pozycjaZKwoty(rentMax);
  return lo <= hi ? [lo, hi] : [hi, hi];
}

/**
 * Filtr z pozycji uchwytów (po puszczeniu suwaka). Uchwyt na krańcu = brak granicy. Obie
 * granice INKLUZYWNE, jak w każdym podpisie („od 3 000", „do 3 500").
 */
export function filtrZSuwaka(lo: number, hi: number): { rentMin?: number; rentMax?: number } {
  const od = kwotaZPozycji(lo);
  const doKwoty = kwotaZPozycji(hi);
  return {
    rentMin: od > CENA_MIN ? od : undefined,
    rentMax: doKwoty < CENA_MAX ? doKwoty : undefined,
  };
}

/**
 * GRANICE WYSYŁANE DO BAZY SĄ PRZESUNIĘTE O 1 ZŁ — i to jest cała sztuczka, która pozwala
 * słupkom zgadzać się z listą.
 *
 * Pomiar 28.09: w każdym koszyku 88–97% ofert ma cenę RÓWNO na granicy (3 000 zł: 504 z 523
 * w [3 000, 3 100); 3 500 zł: 455 z 480). `offers_price_histogram` liczy koszyki półotwarte
 * [dol, gora), a lista filtruje „do 3 500" jako `lte 3500` — przy granicach 1:1 słupki
 * pomijałyby właśnie te 455 ofert, które lista pokazuje.
 *
 * Ceny są całkowite (`rent_pln`, `total_monthly_cost_pln` to integer), więc [g+1, h+1) to
 * dokładnie (g, h]: koszyk zawiera swoją GÓRNĄ granicę. „Do 3 500" = słupki do 3 500 =
 * lista, co do oferty. Dolna granica („od 3 000", `gte`) obejmuje dodatkowo oferty za równe
 * 3 000 zł, które leżą w słupku (2 900, 3 000] — histogram pokazuje go wtedy jako częściowo
 * zaznaczony. Wybrana strona nie jest przypadkowa: górna granica to budżet, najczęstszy filtr
 * (ustawia go też profil najemcy), więc ona ma być dokładna.
 *
 * Bez migracji: funkcja przyjmuje dowolną rosnącą tablicę (migracja 20260928112945).
 */
export const GRANICE_DO_BAZY: readonly number[] = GRANICE_CENY.map((g) => g + 1);

/** Granica z wiersza bazy (przesunięta o 1) z powrotem na kwotę ze skali. */
export function granicaZBazy(v: number | null): number | null {
  return v == null ? null : v - 1;
}

/**
 * Kwota z pola „od / do": cyfry z tekstu (spacje tysięcy, „zł", kropki są ignorowane).
 * Puste albo zero → null, czyli brak granicy.
 */
/**
 * Tekst pola kwoty W TRAKCIE PISANIA: zostają cyfry i odstępy (zwykła spacja, twarda i wąska —
 * tak `formatLiczby` rozdziela tysiące), reszta wypada — przy pisaniu i przy wklejaniu.
 * 29.09 Piotr miał w polu „Od” słowo „kawalerka”: pole przyjmowało litery, a zatwierdzenie po
 * cichu robiło z nich „bez limitu”. Wklejone „3 500 zł” daje „3 500”.
 */
export function tekstPolaKwoty(surowy: string): string {
  return surowy.replace(/[^\d\s\u00a0\u202f]/g, '').replace(/^[\s\u00a0\u202f]+/, '').replace(/[\s\u00a0\u202f]+$/, '');
}

export function kwotaZPola(tekst: string): number | null {
  const cyfry = tekst.replace(/\D/g, '');
  if (!cyfry) return null;
  const v = Number(cyfry);
  return Number.isFinite(v) && v > 0 ? v : null;
}

/**
 * Zatwierdzenie pól „od / do": gdy „od" wyszło większe niż „do", zamieniamy je miejscami —
 * człowiek wpisał dwie kwoty, a nie chciał pustego wyniku.
 */
export function uporzadkujZakres(od: number | null, doKwoty: number | null): { rentMin?: number; rentMax?: number } {
  if (od != null && doKwoty != null && od > doKwoty) return { rentMin: doKwoty, rentMax: od };
  return { rentMin: od ?? undefined, rentMax: doKwoty ?? undefined };
}
